import { UnequipItemCommand } from "../../core/commands/UnequipItemCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction } from "../Interaction";

export const removeInteraction: Interaction = {
  id: "remove",
  label: "Remove",
  scope: "inventory",
  canExecute: (ctx) => {
    if (!ctx.actorId || !ctx.slot) return false;
    const character = ctx.world.getEntity(ctx.actorId);
    const characterComponent = character && getComponent(character, "character");
    return characterComponent?.clothing[ctx.slot] !== undefined;
  },
  execute: async (ctx) => {
    if (!ctx.actorId || !ctx.slot) return { success: false };
    ctx.commands.execute(new UnequipItemCommand(ctx.actorId, ctx.slot));
    return { success: true };
  },
};
